module.exports = __webpack_public_path__ + "static/img/loading.07bca3e1.png";